module.exports = __webpack_public_path__ + "img/lidiia-founder.e1e6b8ce.webp";